"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var axios_1 = tslib_1.__importDefault(require("axios"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_1 = tslib_1.__importStar(require("react"));
require("react-dropdown/style.css");
var react_select_1 = tslib_1.__importDefault(require("react-select"));
require("./styles.less");
var util_1 = require("./util");
var delayDebounceFn;
var ScreenInput = function (_a) {
    var course = _a.course, setCourse = _a.setCourse, courseList = _a.courseList, setCourseList = _a.setCourseList, parThree = _a.parThree, parFour = _a.parFour, parFive = _a.parFive, setParThree = _a.setParThree, setParFour = _a.setParFour, setParFive = _a.setParFive, sevenIronDistance = _a.sevenIronDistance, setSevenIronDistance = _a.setSevenIronDistance, token = _a.token, endpoint = _a.endpoint, setErrorMessage = _a.setErrorMessage, gender = _a.gender, setGender = _a.setGender, setCourseDetails = _a.setCourseDetails;
    var _b = react_1.useState(false), showSevenIronHelp = _b[0], setShowSevenIronHelp = _b[1];
    var delay = 1000;
    var handleGenderChange = function (ev) {
        setGender(ev.target.value);
    };
    var sevenIronDistanceChange = function (ev) {
        var value = parseInt(ev.target.value, 10);
        setShowSevenIronHelp(false);
        setSevenIronDistance(value || 0);
    };
    var parThreeChange = function (ev) {
        var value = parseInt(ev.target.value, 10);
        setParThree(value || 0);
    };
    var parFourChange = function (ev) {
        var value = parseInt(ev.target.value, 10);
        setParFour(value || 0);
    };
    var parFiveChange = function (ev) {
        var value = parseInt(ev.target.value, 10);
        setParFive(value || 0);
    };
    var toggleSevenIronHelp = function () {
        setShowSevenIronHelp(true);
    };
    var convertCourseDetails = function (courseDetailsData) {
        var maxMaleYardage = 0;
        var maxFemaleYardage = 0;
        var resultMap = new Map();
        var teeSetMale;
        var teeSetFemale;
        if (courseDetailsData && courseDetailsData.TeeSets) {
            for (var _i = 0, _a = courseDetailsData.TeeSets; _i < _a.length; _i++) {
                var elem = _a[_i];
                if (elem.HolesNumber === 18 &&
                    elem.TotalYardage > maxMaleYardage &&
                    'Male' === elem.Gender) {
                    maxMaleYardage = elem.TotalYardage;
                    teeSetMale = elem;
                }
                else if (elem.HolesNumber === 18 &&
                    elem.TotalYardage > maxFemaleYardage &&
                    'Female' === elem.Gender) {
                    maxFemaleYardage = elem.TotalYardage;
                    teeSetFemale = elem;
                }
            }
            [teeSetFemale, teeSetMale].forEach(function (teeSet) {
                var map = new Map();
                map.set(3, 0);
                map.set(4, 0);
                map.set(5, 0);
                if (teeSet && teeSet.Gender && teeSet.Holes) {
                    teeSet.Holes.forEach(function (elem) {
                        map.set(elem.Par, map.get(elem.Par) + 1);
                    });
                    resultMap.set(teeSet.Gender, {
                        par3: map.get(3),
                        par4: map.get(4),
                        par5: map.get(5),
                        coursePar: teeSet && teeSet.TotalPar || 0,
                    });
                }
            });
        }
        return resultMap;
    };
    var executeSearch = function (valObj) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var result, e_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!valObj || !valObj.name || valObj.name.length < 3) {
                        return [2 /*return*/, []];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios_1.default.get(endpoint + 'facilities/search.json', {
                            headers: {
                                'Access-Control-Allow-Headers': 'Authorization',
                                'Authorization': "Bearer " + token,
                            },
                            params: tslib_1.__assign(tslib_1.__assign({}, valObj), { country: 'USA', course_status: 'Active' }),
                        })
                            .then(function (response) { return response.data; })];
                case 2:
                    result = _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    console.log('HERE error', e_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, convertCourseList(result, valObj.name)];
            }
        });
    }); };
    var executeCourseDetailsSearch = function (courseId) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var result, err_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!courseId) {
                        return [2 /*return*/, new Map()];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios_1.default.get(endpoint + ("courses/" + courseId + ".json"), {
                            headers: {
                                'Access-Control-Allow-Headers': 'Authorization',
                                'Authorization': "Bearer " + token,
                            },
                        })
                            .then(function (response) { return response.data; })];
                case 2:
                    result = _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    setErrorMessage(err_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, convertCourseDetails(result)];
            }
        });
    }); };
    var onChange = function (change, actionMeta) {
        if (actionMeta.action === 'select-option') {
            setCourse(change);
            executeCourseDetailsSearch(change ? change.value : '')
                .then(function (details) {
                setCourseDetails(details);
            });
        }
    };
    var handleTextChange = react_1.useCallback(function (text) {
        if (delayDebounceFn) {
            clearTimeout(delayDebounceFn);
        }
        // @ts-ignore
        delayDebounceFn = setTimeout(function () {
            executeSearch({ name: text })
                .then(function (r) {
                setCourseList(r);
            });
        }, delay);
    }, [delay, executeSearch]);
    var onInputChange = function (inputValue, actionMeta) {
        if (actionMeta.action === 'input-change'
            && inputValue
            && inputValue.length >= 3) {
            handleTextChange(inputValue);
        }
    };
    var capitalize = function (str, lower) {
        if (lower === void 0) { lower = false; }
        return (lower ? str.toLowerCase() : str).replace(/(?:^|\s|["'([{])+\S/g, function (match) { return match.toUpperCase(); });
    };
    var createLabel = function (item) {
        return item.courseName + ", " + item.State;
    };
    var createCourseName = function (facilityName, courseName) {
        var result;
        if (facilityName && facilityName.toLowerCase().includes(courseName && courseName.toLowerCase())) {
            result = facilityName;
        }
        else {
            result = facilityName + ", " + courseName;
        }
        return capitalize(result, true);
    };
    var convertCourses = function (facility) {
        var state = (facility.State || '').replace('US-', '');
        return facility.Courses && facility.Courses.map(function (item) {
            return tslib_1.__assign(tslib_1.__assign({}, item), { State: state, courseName: createCourseName(facility.FacilityName, item.CourseName) });
        });
    };
    var convertCourseList = function (facilities, val) {
        var courses = [];
        if (!facilities || facilities.length === 0) {
            return courses;
        }
        // @ts-ignore
        var allCourses = [];
        // @ts-ignore
        facilities.filter(function (_a) {
            var Associations = _a.Associations;
            return Associations && Associations.length > 0 && !Associations.find(
            // @ts-ignore
            function (_a) {
                var AssociationName = _a.AssociationName;
                return AssociationName === 'USGA';
            });
        })
            .forEach(function (facility) {
            allCourses.push.apply(allCourses, convertCourses(facility));
        });
        var searchVal = val && val.toLowerCase();
        // @ts-ignore
        courses = allCourses.filter(function (item) {
            return (item.NumberOfHoles === 18 || item.NumberOfHoles === null) &&
                item.courseName &&
                item.CourseStatus === 'Active' &&
                item.courseName.toLowerCase().includes(searchVal);
        }).map(function (item) {
            return { label: createLabel(item), value: item.CourseId };
        });
        courses.sort(function (a, b) {
            return a.label.localeCompare(b.label);
        });
        return courses;
    };
    var courseDropdown = function () {
        return (react_1.default.createElement(react_select_1.default, { className: 'react-select-container', classNamePrefix: 'react-select', value: course, options: courseList, onChange: onChange, onInputChange: onInputChange }));
    };
    return (react_1.default.createElement("div", { className: 'form' },
        react_1.default.createElement("div", { className: 'flex-column first center' },
            react_1.default.createElement("div", { className: 'gender-select-section' },
                react_1.default.createElement("div", { id: 'gender-select', className: 'input-section' },
                    react_1.default.createElement("label", { className: 'gender-select-label' },
                        "Sex:",
                        react_1.default.createElement("span", null, "*")),
                    react_1.default.createElement("label", { className: classnames_1.default('radio-label', gender === util_1.GENDER_OPTIONS.MALE ? 'active' : ''), htmlFor: util_1.GENDER_OPTIONS.MALE },
                        react_1.default.createElement("input", { type: 'radio', name: 'gender-select', className: 'radio-option', id: util_1.GENDER_OPTIONS.MALE, value: util_1.GENDER_OPTIONS.MALE, onChange: handleGenderChange, checked: gender === util_1.GENDER_OPTIONS.MALE }),
                        react_1.default.createElement("span", null, "Male")),
                    react_1.default.createElement("label", { className: classnames_1.default('radio-label', gender === util_1.GENDER_OPTIONS.FEMALE ? 'active' : ''), htmlFor: util_1.GENDER_OPTIONS.FEMALE },
                        react_1.default.createElement("input", { type: 'radio', name: 'gender-select', className: 'radio-option', id: util_1.GENDER_OPTIONS.FEMALE, value: util_1.GENDER_OPTIONS.FEMALE, onChange: handleGenderChange, checked: gender === util_1.GENDER_OPTIONS.FEMALE }),
                        react_1.default.createElement("span", null, "Female"))),
                react_1.default.createElement("label", { className: 'gender-select-label-note', htmlFor: 'gender-select' },
                    react_1.default.createElement("span", null, "Note: Sex is used to identify course par values for male or female")))),
        !!gender && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: 'flex-column' },
                react_1.default.createElement("div", { className: 'seven-iron-distance-section' },
                    react_1.default.createElement("label", { className: 'seven-iron-distance-label', htmlFor: 'seven-iron-distance-input' },
                        "Enter Total 7-Iron distance (Min 80, Max 180):",
                        react_1.default.createElement("span", { onClick: toggleSevenIronHelp, className: 'seven-iron-help' }, "i")),
                    react_1.default.createElement("input", { type: 'text', id: 'seven-iron-distance-input', value: sevenIronDistance, onChange: sevenIronDistanceChange, min: 80, max: 180, maxLength: 3, className: 'seven-iron-distance-input' })),
                showSevenIronHelp && (react_1.default.createElement("div", { className: 'seven-iron-help-message' }, "This is the AVERAGE total hitting distance of your 7-iron including carry, bounce and roll on a flat hole of normal firmness and grass height."))))),
        !!gender && !!sevenIronDistance && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: 'flex-column course-choice' },
                react_1.default.createElement("div", { className: 'course-section' },
                    react_1.default.createElement("label", { className: 'course-label', htmlFor: 'course-container' }, "Enter Course:"),
                    react_1.default.createElement("div", { className: 'course-container', id: 'course-container' }, courseDropdown()))),
            react_1.default.createElement("div", { className: 'flex-column or-label' },
                react_1.default.createElement("div", { className: 'input-section' },
                    react_1.default.createElement("label", { className: 'or-label' },
                        react_1.default.createElement("span", null, "-OR-")))),
            react_1.default.createElement("div", { className: 'flex-column course-details' },
                react_1.default.createElement("div", { className: 'course-details-section' },
                    react_1.default.createElement("label", { className: 'course-details-label', htmlFor: 'par-container' }, "Course Design"),
                    react_1.default.createElement("div", { className: 'par-container', id: 'par-container' },
                        react_1.default.createElement("div", { className: 'par-cell' },
                            react_1.default.createElement("label", { className: 'par-cell-label', htmlFor: 'par-three-input' }, "# of Par 3s:"),
                            react_1.default.createElement("input", { type: 'text', id: 'par-three-input', value: parThree, onChange: parThreeChange, className: 'par-three-input', min: 0, max: 18, maxLength: 2 })),
                        react_1.default.createElement("div", { className: 'par-cell' },
                            react_1.default.createElement("label", { className: 'par-cell-label', htmlFor: 'par-four-input' }, "# of Par 4s:"),
                            react_1.default.createElement("input", { type: 'text', id: 'par-four-input', value: parFour, onChange: parFourChange, className: 'par-four-input', min: 0, max: 18, maxLength: 2 })),
                        react_1.default.createElement("div", { className: 'par-cell' },
                            react_1.default.createElement("label", { className: 'par-cell-label', htmlFor: 'par-five-input' }, "# of Par 5s:"),
                            react_1.default.createElement("input", { type: 'text', id: 'par-five-input', value: parFive, onChange: parFiveChange, className: 'par-five-input', min: 0, max: 18, maxLength: 2 })))))))));
};
exports.default = ScreenInput;
